import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';
import { addModifier } from '../../player.type';
import { ModifierPriority } from '../../modifier.type';

export class DryadTrait extends Trait {
  static baseType = TraitType.Dryad;
  static baseTitle = 'Bark Skin';
  static baseText =
    'When gaining block, gain an equal amount of ward. When gaining ward, gain an equal amount of block.';
  static baseIcon = 'trait';

  type = DryadTrait.baseType;
  title = DryadTrait.baseTitle;
  text = DryadTrait.baseText;
  icon = DryadTrait.baseIcon;

  modifierAdd(type: StatusEffect, stacks: number, params: any): number {
    if (params && params.propagate === false) return stacks;
    if (type == StatusEffect.Block) {
      addModifier(this.owner, StatusEffect.Ward, stacks, { propagate: false });
    } else if (type == StatusEffect.Ward) {
      addModifier(this.owner, StatusEffect.Block, stacks, { propagate: false });
    }
    return stacks;
  }
}

TraitRegistry.register(DryadTrait.baseType, DryadTrait);
